import { Button } from "@chakra-ui/button";
import React from "react";
import { Item } from "src/components/Inputs/SearchSelect";
import { ConditionalTooltip } from "src/components/Layout/ConditionalTooltip";
import { useEnrollmentPeriod } from "src/components/Providers/EnrollmentPeriodProvider";
import { useDashboardExport } from "./useDashboardExport";

type Props = {
  selectedFormTemplate: Item | null;
  hasSchoolSelectionSection: boolean;
};
export const ExportButton: React.FC<Props> = ({
  hasSchoolSelectionSection,
  selectedFormTemplate,
}) => {
  const enrollmentPeriodsContext = useEnrollmentPeriod();
  const { exportToPdf, isExporting } = useDashboardExport({
    enrollmentPeriodName:
      enrollmentPeriodsContext.selectedEnrollmentPeriod?.name ?? "",
    formName: selectedFormTemplate?.label ?? "",
    hasSchoolSelectionSection,
  });

  const isExportDisabled = selectedFormTemplate === null;

  return (
    <ConditionalTooltip
      showTooltip={isExportDisabled}
      label="No data to export"
      hasArrow
    >
      <Button
        width="10rem"
        onClick={exportToPdf}
        isLoading={isExporting}
        isDisabled={isExportDisabled}
        data-print-hide
      >
        Export
      </Button>
    </ConditionalTooltip>
  );
};
